export const from = 4;
export const to = 5;

export function up(schema) {
  return {
    ...schema,
    animation: addLayerProperty(schema.animation, 0),
    text: addLayerProperty(schema.text, 0),
    foreground: addLayerProperty(schema.foreground, 1),
    image: addLayerProperty(schema.image, 2),
    video: addLayerProperty(schema.video, 2),
    audio: addLayerProperty(schema.audio, 3),
    version: to,
  };
}

export function down(schema) {
  // No need to remove the "layer" property
  return {
    ...schema,
    version: from,
  };
}

export default {
  from,
  to,
  up,
  down,
};

function addLayerProperty(items = [], layer) {
  return items.map((item) => ({ layer, ...item }));
}
